// @givmo/app-charity — skip-to-content link (CPA-DP1 floor B11).
//
// The first focusable element in both chromes. Without it, a keyboard or screen-reader caller reaching
// the claim funnel tabs through the whole header — brand, help, account, sign out, and in the SaaS
// shell the entire sidebar — before every single navigation, on a flow whose whole job is to get one
// short form filled in.
//
// Visually hidden until focused (`sr-only` / `focus:not-sr-only`), which is the standard treatment: it
// must not alter the composition for anyone who does not need it.
//
// Both shells render it, and both give their `<main>` the shared id + `tabIndex={-1}` so the anchor
// actually moves focus (an element with no tabindex is a scroll target but not a focus target).

import { testIdProp } from '@givmo/design-system';

/** The id the skip link targets — kept beside the link so the two cannot drift apart. */
export const MAIN_CONTENT_ID = 'charity-main-content';

export function SkipToContent() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only rounded-md bg-surface font-sans text-s14 font-w600 tracking-givmo text-brand-700 shadow-ring focus:not-sr-only focus:absolute focus:left-16 focus:top-16 focus:z-50 focus:px-16 focus:py-8"
      {...testIdProp('charity-skip-to-content')}
    >
      Skip to main content
    </a>
  );
}
